import React, { useEffect, useState } from "react";
import Input from "../../components/shared/input";
import Button from "../../components/shared/button";
import { message, Select } from "antd";
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from "react-i18next";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { changePassword } from "../../APIs/userAuthApi";
import { showErrorToast, showSuccessToast } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";

const Setting = () => {
  const { Option } = Select;
  const [activeSection, setActiveSection] = useState("information");
  const [userDetails, setUserDetails] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const options = [
    { label: "Personal Information", value: "information" },
    { label: "Change Password", value: "password" },
  ];

  const handleSelectChange = (value) => {
    setActiveSection(value);
  };

  useEffect(() => {
    const userDetails = secureLocalStorage.getItem("loginCredentials");
    setUserDetails(userDetails);
  }, []);

  // console.log(userDetails?.user?.email || "");

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Please confirm your password"),
  });

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: (values) => {
      changePassword(values.oldPassword, values.newPassword)
        .then((res) => {
          console.log(res);
          // showSuccessToast(res.message, 3000);
          message.success(res.message);
          navigate("/dashboard");
        })
        .catch((err) => {
          // showErrorToast(err, 3000);
          message.error(err);
        });
    },
  });
  return (
    <>
      <div className="setting-main h-[100%] pt-[55px] flex d-flex gap-[10px] sm-s:flex-col sm-s:items-center">
        {/* Sidebar Switcher */}
        <div className="switcher drop-shadow-md h-[570px] sm-s:hidden max-w-[22%] w-full flex flex-col gap-[8px] bg-[#F8F8F8] px-[5px] py-[25px] border-r-2 border-r-[#fff] border-solid rounded-[28px]">
          <p
            className={`text-center text-blue font-medium font-manrope medium py-[12px] cursor-pointer ${
              activeSection === "information" ? " bg-darkblue bg-opacity-[0.1] rounded-[6px]" : ""
            }`}
            onClick={() => setActiveSection("information")}
          >
            {t("dashboard.settings.personalInformation")}
          </p>
          <p
            className={`text-center text-blue font-medium font-manrope medium py-[12px] cursor-pointer ${
              activeSection === "password" ? " bg-darkblue bg-opacity-[0.1] rounded-[6px]" : ""
            }`}
            onClick={() => setActiveSection("password")}
          >
            {t("dashboard.settings.changePassword")}
          </p>
        </div>
        <Select
          placeholder="Select Section"
          style={{ width: 200 }}
          className="graph-dropdown hidden sm-s:block"
          onChange={handleSelectChange}
          value={activeSection}
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        {/* Main Content Area */}
        <div className="switcher-content drop-shadow-md w-full max-w-[74%] sm-s:max-w-full bg-[#F8F8F8] px-[30px] sm-s:px-[20px] py-[25px] border-r-2 border-r-[#fff] border-solid rounded-[28px]">
          {/* Personal Information Content */}
          {activeSection === "information" && (
            <div className="information-div flex flex-col gap-[50px]">
              <div className="flex flex-col gap-[6px]">
                <h5 className="text-blue font-bold font-manrope small leading-[20px]">
                  {t("dashboard.settings.personalInformation")}
                </h5>
                <p className="font-manrope text-blue e-small leading-[20px]">
                  {t("dashboard.settings.customizePersonalInformation")}
                </p>
              </div>
              <div className="flex flex-col gap-[7px]">
                <Input
                  label={t("dashboard.settings.name")}
                  type="text"
                  name="text"
                  placeholder={t("dashboard.settings.name")}
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                  maxWidth="60%"
                />
                <Input
                  label={t("dashboard.settings.lastName")}
                  type="text"
                  name="text"
                  placeholder={t("dashboard.settings.lastName")}
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                  maxWidth="60%"
                />
                <Input
                  value={userDetails?.user?.email || ""}
                  label={t("dashboard.settings.email")}
                  type="text"
                  name="text"
                  placeholder={t("dashboard.settings.email")}
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                  maxWidth="60%"
                />
              </div>
              <Button
                text={t("dashboard.settings.saveChanges")}
                className="button btn-blue !rounded-[39px] large mt-[75px] ml-auto px-6"
                height={45}
              />
            </div>
          )}

          {/* Change Password Content */}
          {activeSection === "password" && (
            // <div className="change-pswd-div flex flex-col gap-[50px]">
            //   <div className="flex flex-col gap-[6px]">
            //     <h5 className="text-blue font-bold font-manrope small leading-[20px]">
            //       {t("dashboard.settings.changePassword")}
            //     </h5>
            //     <p className="font-manrope text-blue e-small leading-[20px]">
            //       {t("dashboard.settings.changeYourPassword")}
            //     </p>
            //   </div>
            //   <div className="flex flex-col gap-[7px]">
            //     <Input
            //       label={t("dashboard.settings.oldPassword")}
            //       type="password"
            //       name="text"
            //       placeholder={t("dashboard.settings.oldPassword")}
            //       className="dash-input-field"
            //       wrapperClass="dash-wrapper"
            //       labelClass="dash-label"
            //       maxWidth="60%"
            //       icon="mingcute:eye-2-fill"
            //     />
            //     <Input
            //       label={t("dashboard.settings.newPassword")}
            //       type="password"
            //       name="text"
            //       placeholder={t("dashboard.settings.newPassword")}
            //       className="dash-input-field"
            //       wrapperClass="dash-wrapper"
            //       labelClass="dash-label"
            //       maxWidth="60%"
            //       icon="mingcute:eye-2-fill"
            //     />
            //     <Input
            //       label={t("dashboard.settings.confirmPassword")}
            //       type="password"
            //       name="text"
            //       placeholder={t("dashboard.settings.confirmPassword")}
            //       className="dash-input-field"
            //       wrapperClass="dash-wrapper"
            //       labelClass="dash-label"
            //       maxWidth="60%"
            //       icon="mingcute:eye-2-fill"
            //     />
            //   </div>
            //   <Button
            //     text={t("dashboard.settings.saveChanges")}
            //     className="button btn-blue !rounded-[39px] large mt-[75px] ml-auto"
            //     height={45}
            //     width={176}
            //   />
            // </div>
            // <Formik
            //   initialValues={{
            //     oldPassword: "",
            //     newPassword: "",
            //     confirmPassword: "",
            //   }}
            //   validationSchema={validationSchema}
            //   onSubmit={handleSubmit}
            // >

            <form
              onSubmit={formik.handleSubmit}
              className="change-pswd-div flex flex-col gap-[50px]"
            >
              <div className="flex flex-col gap-[6px]">
                <h5 className="text-blue font-bold font-manrope small leading-[20px]">
                  {t("dashboard.settings.changePassword")}
                </h5>
                <p className="font-manrope text-blue e-small leading-[20px]">
                  {t("dashboard.settings.changeYourPassword")}
                </p>
              </div>
              <div className="flex flex-col gap-[7px]">
                {/* Old Password Field */}
                <div>
                  <Input
                    label={t("dashboard.settings.oldPassword")}
                    type="password"
                    name="oldPassword" // Update name to match the key in formik.initialValues
                    placeholder={t("dashboard.settings.oldPassword")}
                    className="dash-input-field"
                    wrapperClass="dash-wrapper"
                    labelClass="dash-label"
                    maxWidth="60%"
                    icon="mingcute:eye-2-fill"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.oldPassword}
                  />
                  {formik.touched.oldPassword && formik.errors.oldPassword && (
                    <div className="text-red-500 text-xs" style={{ color: "red" }}>
                      {formik.errors.oldPassword}
                    </div>
                  )}
                </div>

                {/* New Password Field */}
                <div>
                  <Input
                    label={t("dashboard.settings.newPassword")}
                    type="password"
                    name="newPassword" // Update name to match the key in formik.initialValues
                    placeholder={t("dashboard.settings.newPassword")}
                    className="dash-input-field"
                    wrapperClass="dash-wrapper"
                    labelClass="dash-label"
                    maxWidth="60%"
                    icon="mingcute:eye-2-fill"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.newPassword}
                  />
                  {formik.touched.newPassword && formik.errors.newPassword && (
                    <div className="text-red-500 text-xs" style={{ color: "red" }}>
                      {formik.errors.newPassword}
                    </div>
                  )}
                </div>

                {/* Confirm Password Field */}
                <div>
                  <Input
                    label={t("dashboard.settings.confirmPassword")}
                    type="password"
                    name="confirmPassword" // Update name to match the key in formik.initialValues
                    placeholder={t("dashboard.settings.confirmPassword")}
                    className="dash-input-field"
                    wrapperClass="dash-wrapper"
                    labelClass="dash-label"
                    maxWidth="60%"
                    icon="mingcute:eye-2-fill"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.confirmPassword}
                  />
                  {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                    <div className="text-red-500 text-xs" style={{ color: "red" }}>
                      {formik.errors.confirmPassword}
                    </div>
                  )}
                </div>
              </div>
              <button
                type="submit"
                className="button btn-blue !rounded-[39px] large mt-[75px] ml-auto"
              >
                Save Changes
              </button>
            </form>

            // </Formik>
          )}
        </div>
      </div>
    </>
  );
};

export default Setting;
